import React from 'react';
import PropTypes from 'prop-types';
import accounting from 'accounting';
import { Button } from '../../Button';
import WelcomeSvg from './hired.svg';
import './PickedFreelancerPopup.css';

export const PickedFreelancerPopup = ({
  handleClose,
  project_name: projectName,
  price,
  deadline,
}) => (
  <div className="picked-freelancer">
    <div className="picked-freelancer__image-container">
      <img
        alt="welcome"
        className="picked-freelancer__image-container__image"
        src={WelcomeSvg}
      />
    </div>
    <div className="picked-freelancer__body">
      <div className="picked-freelancer__body__title">
        Congrats You’ve Been Awarded This Project
      </div>
      <div className="picked-freelancer__body__description">
        <h3>{projectName}</h3>
        <br />A client chose you for their project so lets get started! Click to
        see project details and start the conversation with your new client now!
      </div>
      <div className="picked-freelancer__body__info">
        <div className="picked-freelancer__body__info-cell">
          <span className="picked-freelancer__body__info-cell-value">
            ${accounting.format(price)}
          </span>
          <span className="picked-freelancer__body__info-cell-desc">
            Your Price
          </span>
        </div>
        <div className="picked-freelancer__body__info-cell">
          <span className="picked-freelancer__body__info-cell-value">
            {deadline}
          </span>
          <span className="picked-freelancer__body__info-cell-desc">
            Deadline
          </span>
        </div>
      </div>
    </div>
    <div className="picked-freelancer__action">
      <Button
        onClick={handleClose}
        className="picked-freelancer__action--continue"
        rounded
        title="Get Started"
      />
    </div>
  </div>
);

PickedFreelancerPopup.propTypes = {
  handleClose: PropTypes.func,
  project_name: PropTypes.string,
  price: PropTypes.number,
  deadline: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/components/Popup/PickedFreelancerPopup/PickedFreelancerPopup.js